module.exports = __webpack_public_path__ + "img/couples-012.15d97c95.jpg";